module.exports = __webpack_public_path__ + "img/logo17.5be9b5c5.jpg";